import graphqlClient from '~/graphql/graphqlClient';
import {
  MutationClaimKongPurchasesArgs,
  KongPurchasesResult,
} from 'dt-common/generated/graphql-types';

const mutation = `
mutation ClaimKongPurchases($playerId: String!, $kongAuthToken: String!, $kongUserId: String!, $platform: String!) {
  claimKongPurchases(playerId: $playerId, kongAuthToken: $kongAuthToken, kongUserId: $kongUserId, platform: $platform) {
    currency1
    pdAmount
  }
}
`;

export default async function mutationClaimKongPurchases(args: MutationClaimKongPurchasesArgs) {
  return await graphqlClient.request<KongPurchasesResult>(
    'claimKongPurchases',
    mutation,
    args
  );
}
